import { SectionHeading } from "./Reveal";
import { FAQS } from "@/lib/content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ = () => {
  return (
    <section id="faq" className="py-[35px] lg:py-[50px] bg-white" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Questions & Answers"
          title="Frequently asked questions"
          subtitle="Everything you need to know about Home Cart."
        />
        <div className="mt-14">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-[#E8E8E8]"
              >
                <AccordionTrigger className="font-heading text-left text-lg sm:text-xl font-semibold text-[#1A1A1A] hover:text-[#F8B808] hover:no-underline py-6">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-[#6B6B66] text-base md:text-lg leading-relaxed pb-6">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
